import { createFileRoute } from '@tanstack/react-router';

import { PerCustomerPage } from '@/areas/settings/manufacturing/Settings/PerCustomerPage/PerCustomerPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/settings/_menu/organization/customer-portal/customer-specific-settings',
)({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <PerCustomerPage />;
}
